/**
 * Variable extraction for notification templates.
 *
 * A deliberately small, client-side scanner. It finds simple interpolation tags
 * such as `{{firstName}}` and `{{reservation.confirmationNumber}}` and ignores
 * control tags (`{{#if}}`, `{{/if}}`, `{{else}}`, `{{#each}}`) so the list it
 * produces is the set of values a sender must provide.
 */

const VARIABLE_TAG = /\{\{\s*([A-Za-z_][A-Za-z0-9_]*(?:\.[A-Za-z_][A-Za-z0-9_]*)?)\s*\}\}/gu;

/**
 * Returns every root variable the body interpolates, sorted and unique.
 *
 * Dotted paths are returned as written (`guest.firstName`), because a sender
 * passes a nested context and the template engine walks the path at render
 * time. The list is what the variables column stores and what the detail
 * screen shows as documentation.
 */
export function extractTemplateVariables(body: string): readonly string[] {
  const found = new Set<string>();

  for (const match of body.matchAll(VARIABLE_TAG)) {
    const name = match[1];
    if (name !== undefined) found.add(name);
  }

  return [...found].sort((left, right) => left.localeCompare(right));
}
